import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRight, ChevronDown, Copy } from 'lucide-react';
import { LEVEL_LABELS, SavedPathway } from '../../../types/pathway';
import { moduleById } from '../../../data/skillModules';
interface SavedPathwayRowProps {
  pathway: SavedPathway;
  expanded: boolean;
  onToggleExpand: () => void;
  onOpen: (pathway: SavedPathway) => void;
  onDuplicate: (pathway: SavedPathway) => void;
}
export function SavedPathwayRow({
  pathway,
  expanded,
  onToggleExpand,
  onOpen,
  onDuplicate
}: SavedPathwayRowProps) {
  return <>
      <tr className="border-b border-gray-100 transition-colors hover:bg-gray-50" data-id="element-1770" data-mp="18ccyp1nop146">
        <td className="px-3 py-4 sm:px-6" data-id="element-1771" data-mp="13djnxgzs7o7p">
          <button type="button" onClick={onToggleExpand} aria-expanded={expanded} className="flex items-start gap-2 text-left" data-id="element-1772" data-mp="13ci7sy3wsbj4">
            <ChevronDown size={16} aria-hidden="true" className={`mt-0.5 flex-shrink-0 text-gray-400 transition-transform ${expanded ? 'rotate-180' : ''}`} data-id="element-1773" data-mp="1w1yx3mw8fcb4" />
            <span data-id="element-1774" data-mp="34e3e3o7f0rhr">
              <span className="block text-sm font-semibold text-gray-900" data-id="element-1775" data-mp="2pn4akrlfst51">
                {pathway.name}
              </span>
              <span className="mt-0.5 block text-xs text-gray-500" data-id="element-1776" data-mp="2ulfjn03wqzm7">
                {pathway.organization} · {pathway.updatedLabel}
              </span>
            </span>
          </button>
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-700 sm:px-6" data-id="element-1777" data-mp="2ko9sjrvan8lz">
          {LEVEL_LABELS[pathway.audience]}
        </td>
        <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-700 sm:px-6" data-id="element-1778" data-mp="26q32uz0i0exe">
          {pathway.moduleIds.length}
        </td>
        <td className="px-3 py-4 sm:px-6" data-id="element-1779" data-mp="4x56wubfd688">
          <div className="flex items-center justify-end gap-4" data-id="element-1780" data-mp="4xeu6a534za8">
            <button type="button" onClick={() => onDuplicate(pathway)} className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-gray-600 transition-colors hover:text-gray-900" data-id="element-1781" data-mp="9w8asbfo56em">
              <Copy size={14} data-id="element-1782" data-mp="3ht0h05ug407" />
              Duplicate
            </button>
            <button type="button" onClick={() => onOpen(pathway)} className="flex items-center gap-1.5 whitespace-nowrap text-sm font-medium text-[#DB3725] transition-colors hover:text-[#c02f1f]" data-id="element-1783" data-mp="3umj9pefxbzxd">
              Edit
              <ArrowRight size={14} data-id="element-1784" data-mp="m5xxzpvwqsqk" />
            </button>
          </div>
        </td>
      </tr>

      <AnimatePresence initial={false} data-id="element-1785" data-mp="hepm8n73uva8">
        {expanded && <tr data-id="element-1786" data-mp="cgeeci0deuun">
            <td colSpan={4} className="border-b border-gray-100 bg-gray-50 p-0" data-id="element-1787" data-mp="cgo8mhsg7o65">
              <motion.div initial={{
            opacity: 0,
            height: 0
          }} animate={{
            opacity: 1,
            height: 'auto'
          }} exit={{
            opacity: 0,
            height: 0
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-1788" data-mp="19vs8w1wo2786">
                <ol className="space-y-1.5 px-3 py-4 sm:px-6" data-id="element-1789" data-mp="1herri5cazuqh">
                  {pathway.moduleIds.map((moduleId, index) => {
                const module = moduleById(moduleId);
                if (!module) return null;
                return <li key={moduleId} className="flex items-baseline gap-3 text-sm" data-id="element-1790" data-mp="1rbea0nh5q9pc" data-mpi={index}>
                        <span className="w-4 flex-shrink-0 text-xs font-bold text-[#30718D]" data-id="element-1791" data-mp="20d43dyulnipr">
                          {index + 1}
                        </span>
                        <span className="font-medium text-gray-900" data-id="element-1792" data-mp="2a3yy7rlwvqmt">
                          {module.name}
                        </span>
                        <span className="text-xs text-gray-500" data-id="element-1793" data-mp="2f44op4gg373b">
                          {module.category}
                        </span>
                      </li>;
              })}
                </ol>
              </motion.div>
            </td>
          </tr>}
      </AnimatePresence>
    </>;
}